<template>
	<v-sheet rounded class="mb-6" elevation="15">
		<v-card color="#125B92" elevation="0" class="rounded">
			<v-card-title class="align-center">
				<h3 class="white--text">Images</h3>
				<v-spacer />
				<v-btn small
					color="default"
					elevation="0"
					@click="uploadToggle = !uploadToggle">
					<v-icon left>mdi-file-plus-outline</v-icon>
					Toggle Uploader
				</v-btn>
			</v-card-title>
			<v-divider />
			<v-card-text class="white pa-5">
				<v-expand-transition>
					<uploader v-if="uploadToggle" v-model="uploading" dialog @uploaded="uploadFiles" />
				</v-expand-transition>

				<div v-if="length(images)" class="report-writer-images-wrapper">
					<v-row>
						<v-col
							v-for="(image, index) in images"
							:key="`rw-image-` + index"
							class="d-flex child-flex position-relative"
							cols="4">
							<v-sheet elevation="1" outlined class="grey lighten-2">
								<v-img
									contain
									:src="image.image"
									class="grey lighten-2 fill-height">
									<template #placeholder>
										<v-row
											class="fill-height ma-0"
											align="center"
											justify="center">
											<v-progress-circular
												indeterminate
												color="grey lighten-5"></v-progress-circular>
										</v-row>
									</template>

									<template #default>
										<div class="d-flex flex-column justify-space-between fill-height">
											<div class="d-flex justify-end ma-2">
												<v-btn fab
													:dark="index !== 0"
													small
													color="blue"
													class="mt-2 mr-2"
													:disabled="index === 0"
													@click="moveImageUp(index)">
													<v-icon dark>mdi-arrow-left</v-icon>
												</v-btn>
												<v-btn
													fab
													small
													color="blue"
													class="mt-2 mr-2"
													:dark="index !== images.length - 1"
													:disabled="index === images.length - 1"
													@click="moveImageDown(index)">
													<v-icon dark>mdi-arrow-right</v-icon>
												</v-btn>
												<v-btn fab
													dark
													small
													color="red"
													class="mt-2 mr-2"
													@click="deleteImage(image)">
													<v-icon dark>mdi-delete-forever</v-icon>
												</v-btn>
											</div>
											<div class="px-4">
												<v-text-field v-model="image.label" label="Label" solo class="w-100"></v-text-field>
											</div>
										</div>
									</template>
								</v-img>
							</v-sheet>
						</v-col>
					</v-row>
				</div>
				<div v-else>
					<v-alert class="ma-0 grey lighten-4">No images exist. <a href="#" @click.prevent="uploadToggle = true">Upload one?</a></v-alert>
				</div>
			</v-card-text>
		</v-card>
	</v-sheet>
</template>
<script>
import Uploader from '@/Pages/Backend/Components/Uploader'
export default {
	components: {
		Uploader
	},

	props: {
		value: {
			type: Array,
			default: () => [],
			required: true
		}
	},

	data () {
		return {
			property: this.$page.props.property,
			images: this.value,
			uploadToggle: false,
			uploading: null
		}
	},

	watch: {
		value (newValue) {
			this.images = newValue
		}
	},

	methods: {
		uploadFiles (files) {
			this.uploading = true

			const route = this.route('properties.data.update', this.property)
			const data = {
				uploads: files
			}

			this.$inertia.post(route, data, {
				preserveState: true,
				preserveScroll: true,
				only: ['property', 'flash'],
				onSuccess: () => {
					this.uploading = false
					this.uploadToggle = false
					this.property = this.$page.props.property
					this.images = this.property.images

					this.$emit('input', [...this.images])
				}
			})
		},
		deleteImage (image) {
			const index = this.images.indexOf(image)
			if (index !== -1) {
				this.images.splice(index, 1)
				this.$emit('input', [...this.images])
			}
		},
		moveImageUp (index) {
			if (index > 0) {
				const temp = this.images[index - 1]
				this.$set(this.images, index - 1, this.images[index])
				this.$set(this.images, index, temp)
				this.$emit('input', [...this.images])
			}
		},
		moveImageDown (index) {
			if (index < this.images.length - 1) {
				const temp = this.images[index + 1]
				this.$set(this.images, index + 1, this.images[index])
				this.$set(this.images, index, temp)
				this.$emit('input', [...this.images])
			}
		}
	}
}
</script>
